import { render, staticRenderFns } from "./PreventativeChallengeMobile.vue?vue&type=template&id=5d1207dc&scoped=true&lang=pug&"
import script from "./PreventativeChallengeMobile.vue?vue&type=script&lang=js&"
export * from "./PreventativeChallengeMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1207dc",
  null
  
)

export default component.exports